import { render } from "./NormalDistributionChart.vue?vue&type=template&id=2b2e6ddc&scoped=true"
import script from "./NormalDistributionChart.vue?vue&type=script&lang=js"
export * from "./NormalDistributionChart.vue?vue&type=script&lang=js"

import "./NormalDistributionChart.vue?vue&type=style&index=0&id=2b2e6ddc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2e6ddc"]])

export default __exports__